// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_1mIST","foot_link":"index_foot_link_BJlRO","list":"index_list_-sEVp","link":"index_link_xlEHS","copyright":"index_copyright_N-D0D"};